import request from '../request';

const server = {
  // 审批管理-采购需求审批-待审批分页
  queryDemandAuditPage(params) {
    return request.post('/purchase/purchaseDemand/queryDemandAuditPage', params);
  },
  // 采购计划审批-已审批分页
  queryPlanApprovedPage(params) {
    return request.post('/purchase/purchaseAudit/queryPlanApprovedPage', params);
  },
  // 审批采购计划
  approvePurchaseDemanAudit(params) {
    return request.post('/purchase/purchaseAudit/approvePurchaseDemand', params);
  },

  // 采购计划审批-已审批分页
  queryDemandApprovedPage(params) {
    return request.post('/purchase/purchaseAudit/queryDemandApprovedPage', params);
  },
  // 采购计划审批-   查看
  queryPurchaseDemandPlanItem(params) {
    return request.post('/purchase/purchaseDemandItem/queryPurchaseDemandPlanItem', params);
  },
  // 审批询比价
  auditEnquiryList(params) {
    return request.post('/transaction-center/enquiryAudit/modifyPurchaseComapanyAuditStatus', params);
  },
  // 采购申请管理判断
  checkProcurementPlan(params) {
    return request.post('/api-register/tenant/checkProcurementPlan', params);
  },

  // 询比价审核列表/enquiryAudit/modifyPurchaseComapanyAuditStatus
  queryAuditEnquiryListByPage(params) {
    return request.post('/transaction-center/enquiryAudit/queryAuditEnquiryListByPage', params);
  },
  // 审批询比价
  auditEnquiryList(params) {
    return request.post('/transaction-center/enquiryAudit/modifyPurchaseComapanyAuditStatus', params);
  },
  // 订单 已审批接口
  approveOrderPageHas(params) {
    return request.post('/transaction-center/purchase/approveOrderPage', params);
  },
  // 审批管理-采购计划审批-待审批分页
  queryPlanAuditPage(params) {
    return request.post('/purchase/purchasePlan/queryPlanAuditPage', params);
  },
  // 查询采购计划详情
  purchasePlanQueryDetail(params) {
    return request.post('/purchase/purchasePlan/queryDetail', params);
  },
  // 待审批订单列表
  waitApproveOrderPage(params) {
    return request.post('/transaction-center/purchase/waitApproveOrderPage', params);
  },

  // 我的订单按钮权限集合
  queryPcButton(params) {
    return request.post('/ubm/button/queryPcButton', params);
  },
  // 判断是否是大权
  checkCompanyAttrValue(params) {
    return request.post('/ubm/companyAttrval/checkCompanyAttrValue', params);
  },
  // 查询审核人
  approveName(params) {
    return request.post('/transaction-center/workflowInstance/listApproveName', params);
  },
  // 详情
  orderDetail(params) {
    return request.post('/transaction-center/purchase/orderDetail', params);
  },
  // 订单详情的审批流
  queryOrderWorkflowList(params) {
    return request.post('/transaction-center/workflowInstance/queryOrderWorkflowList', params);
  },
  // 商品列表
  listPurchaseSku(params) {
    return request.post('/transaction-center/orderSku/listPurchaseSku', params);
  },
  // 审核
  approveOrder(params) {
    return request.post('/transaction-center/purchase/approveOrder', params);
  },

  // 公共
  addAudit(params) {
    return request.post('/purchase/audit/addAudit', params);
  },

  // 公告 待审批
  queryAuditPage(params) {
    return request.post('/cms/purchaseAnnouncement/queryAuditPage', params);
  },
  // 公共 已审批
  queryReviewedPage(params) {
    return request.post('/cms/purchaseAnnouncement/queryReviewedPage', params);
  },
  // 公共 批量审批
  batchAudit(params) {
    return request.post('/cms/purchaseAnnouncement/batchAudit', params);
  },
};

export default server;
